import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Avatar, Button, Dropdown, Typography } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { resolveImageUrl } from "../../utils/image";
import { spacing } from "../../theme/tokens";

const { Text } = Typography;

/**
 * Avatar + dropdown thông tin tài khoản, có nút đăng xuất.
 * Tách khỏi `HeaderConek` để phần khung chỉ còn việc bố cục.
 */
export default function UserMenu({ user, onLogout }) {
  const [open, setOpen] = useState(false);
  const info = user?.data;
  if (!info) return null;

  const avatar = info.avatar ? resolveImageUrl(info.avatar) : null;

  const items = [
    info.username && { key: "username", label: <Text>{info.username}</Text> },
    info.email && { key: "email", label: <Text>{info.email}</Text> },
    info.phone && { key: "phone", label: <Text>{info.phone}</Text> },
    {
      key: "logout",
      label: (
        <Button type="primary" danger icon={<LogoutOutlined />} onClick={onLogout}>
          Đăng xuất
        </Button>
      ),
    },
  ].filter(Boolean);

  return (
    <Dropdown menu={{ items }} trigger={["click"]} open={open} onOpenChange={setOpen}>
      <div style={{ lineHeight: "20px", marginRight: spacing[2], cursor: "pointer" }}>
        <Avatar size={40} src={avatar} icon={avatar ? null : <UserOutlined />} />
      </div>
    </Dropdown>
  );
}

/** Bản rút gọn cho Drawer mobile — cùng dữ liệu, khác cách bày. */
export function UserSummary({ user, nameLabel }) {
  const info = user?.data;
  const avatar = info?.avatar ? resolveImageUrl(info.avatar) : null;
  return (
    <>
      <Avatar size={40} src={avatar} icon={avatar ? null : <UserOutlined />} />
      <NavLink to="/editUser">{nameLabel}</NavLink>
    </>
  );
}
